export default {
  common: {
    operation_success: "Действие успешно выполнено",
    success_add: "Успешное добавление",
    success_remove: "Успешное удаление",
    logout: "Выход",
    test: "Тестировать",
    edit: "Редактировать",
    upload: "Загрузить",
    remove: "Удалить",
    save: "Сохранить",
    cancel: "Отмена",
    example: 'Пример',
    site: "Сайт",
    is_enabled: "Активен",
    is_disabled: "Отключен",
    copy: "Копировать",
    text_has_been_copied_to_clipboard: "Текст скопирован в буфер обмена",
    legal_name: "Название компании",
    inn: "ИНН",
    kpp: "КПП",
    address: "Адрес",
    company_details: "Реквизиты компании",
    success_register: "Регистрация успешно завершена",
  },
  sites: {
    title: "Сайты",
    add_site: "Добавить сайт",
    domain: "Домен",
    identifier: "Идентификатор",
    landing_page: "Страница приземления(прайс-листа)",
    catalog_header: "Шапка каталога",
    catalog_title:"Заголовок каталога",
    breadcrumbs:"Скрыть строку навигации(хлебные крошки)",
    link_to_site_in_breadcrumbs: "Скрыть сcылку на сайт в хлебных крошках",
    add_custom_css_file: "Добавить свой файл стилей(css)",
    landing_page_part_number_definition: '- заменяется на номер запчасти из каталога (обязательно нужно использовать)',
    landing_page_brand_definition: '- заменяется на производителя запчасти из каталога (не обязательно использовать)',
    landing_page_example: "пример страницы приземления",
    landing_page_example_bremi_12345: "страница приземления если выбрать в каталоге деталь Bremi 12345\n",
  },
  catalogs_groups: {
    title: "Группы каталогов",
    catalog:"Каталог",
    link_to_catalog: "Ссылка на каталог",
    code_for_site: "Код для вставки на сайт",
    iframe_code: "Вставка в IFrame",
    insert_a_link_to_the_catalog: "Вставка ссылки на каталог"
  },
  payments: {
    original_catalog_service: "Cервис оригинальных каталогов",
    special_catalog_service: "Сервис специальных каталогов",
    select_all_with_discount:"Выбрать все со скидкой",
    title: "Оплата",
    catalog_group: "Группа каталогов",
    rent_period: "Срок аренды",
    hide_footer: "Скрыть подвал",
    price_per_month: "Цена за месяц",
    status: "Текущий статус",
    sum: "Сумма",
    total_sum: "Итого к оплате",
    per_month: "в месяц",
    pay: "Оплатить",
    card: "Карта",
    invoice: "Счёт",
    payment_type: "Тип оплаты",
    error_choose_payment_type: "Выберите тип оплаты",
    payment_success: "Платеж успешно прошел",
    payment_failed: "Ошибка проведения платежа",
  },
  support: {
    title: "Поддержка"
  },
  docs: {
    title: "Документация"
  },
  passwordRecovery:{
    email: "Ваш e-mail",
    title: "Восстановление пароля",
    success_text: "Пароль отправлен на указанный адрес электронной почты",
    recovery: "Восстановить"
  },
  form: {
    login: {
      title: "Авторизация",
      email: "E-mail",
      password: "Пароль",
      password_confirmation: "Повтор пароля",
      login: "Войти",
      register:"Регистрация",
      forgot_password: "Забыли пароль",
      name: "Имя",
    },
    validationErrors: {
      field_is_required: "Поле обязательно для заполнения",
      min_length: "Длина должна быть больше {0} символов",
      must_be_greater: "Должно быть больше чем {0}",
      field_must_be_contain: "Поле должно содержать {0}",
      password_confirmation_doesnt_match: "Пароли не совпадают", //
      email_not_valid: "Не верный формат адреса", //Must be valid e-mail
    },
    confirmation:{
      success_title: "Вы успешно подтвердили свой e-mail",
      title: "Для продолжения работы с сервисом, пожалуйста подтвердите ваш e-mail",
      resend_code: "Отправить код повторно",
      send_code: "Отправить код подтверждения",
      code_label: "Код из e-mail"
    }
  },
};
